var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Children } from 'react';
import Button from '@r1-frontend/ui-react/components/buttons/button';
import Cookie from '@r1-frontend/ui-react/components/emoji/emoji/Cookie';
import { InfoCircle, InfoCircleFlip, TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import * as S from './styled';
var getAlertState = function (type) {
    var map = {
        error: [InfoCircle, COLORS.BgError],
        success: [TickCircle, COLORS.BgSuccess],
        info: [InfoCircleFlip, COLORS.BgSurface],
        transparent: [InfoCircleFlip, COLORS.transparent],
        white: [Cookie, COLORS.BgMain],
    };
    return map[type];
};
var Alert = function (_a) {
    var Icon = _a.Icon, children = _a.children, _b = _a.type, type = _b === void 0 ? 'info' : _b, _c = _a.withShadow, withShadow = _c === void 0 ? false : _c, props = __rest(_a, ["Icon", "children", "type", "withShadow"]);
    var _d = getAlertState(type), PredifinedIcon = _d[0], background = _d[1];
    var _e = Children.toArray(children), content = _e[0], buttons = _e[1];
    return (<S.Alert $radius={32} type={type} withShadow={withShadow} background={background} className={props.className}>
            <ListContainer $size={8}>
                <S.AlertIcon>
                    {Icon ? <Icon /> : <PredifinedIcon />}
                </S.AlertIcon>
                {content}
            </ListContainer>
            {buttons}
        </S.Alert>);
};
export var AlertButtons = function (_a) {
    var children = _a.children;
    if (Children.count(children) > 2) {
        throw new Error('@r1-frontend/ui-react. The "AlertButtons" cannot contain more than 2 buttons');
    }
    return (<S.AlertButtons>
            <IndentContainer $desktop={[0, 0, 0, 16]} $mobile={[12, 0, 0]}>
                <ListContainer data-test={'buttons-container'} $wrap={'nowrap'} $size={8}>
                    {children}
                </ListContainer>
            </IndentContainer>
        </S.AlertButtons>);
};
var getAlertPrimaryButtonType = function (type) {
    var map = {
        error: 'action',
        success: 'primary',
        info: 'secondary',
        transparent: 'secondary',
        white: 'white',
    };
    return map[type];
};
export var ActionAlert = function (_a) {
    var type = _a.type, children = _a.children, _b = _a.button, label = _b.label, onClick = _b.onClick;
    return (<Alert type={type}>
            {children}
            <AlertButtons>
                <Button data-test={'button'} size={'small'} bType={getAlertPrimaryButtonType(type)} onClick={onClick}>
                    {label}
                </Button>
            </AlertButtons>
        </Alert>);
};
export var ConfirmAlert = function (_a) {
    var type = _a.type, children = _a.children, buttons = _a.buttons;
    return (<Alert type={type}>
            {children}
            <AlertButtons>
                {buttons.map(function (_a, index) {
            var label = _a.label, onClick = _a.onClick, _b = _a.btnType, btnType = _b === void 0 ? 'white' : _b, isLoading = _a.isLoading;
            return (<Button data-test={"button-".concat(index)} key={index} size={'small'} bType={index ? btnType : getAlertPrimaryButtonType(type)} onClick={onClick} loading={isLoading}>
                        {label}
                    </Button>);
        })}
            </AlertButtons>
        </Alert>);
};
export default Alert;
